import type { ChangeEvent, FC } from "react"

import style from "./style.module.scss"

type Props = {
  checked: boolean
  onChange: (value: boolean) => void
}

export const Checkbox: FC<Props> = ({ checked, onChange }) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked)
  }

  return <input className={style.checkbox} type="checkbox" checked={checked} onChange={handleChange} />
}
